var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"nocopy",attrs:{"data-testid":"text"}},[(_vm.imageUrl)?[_c('img',{staticClass:"qImg",attrs:{"src":_vm.imageUrl}})]:_vm._e(),_vm._v(" "+_vm._s(_vm.questionText)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }